import keyMirror from 'keymirror';
import { createAction } from 'redux-actions';

export const types = keyMirror({
  PRODUCT_API_HOC_RESET: null,
});

export const resetProductApiHOC = createAction(types.PRODUCT_API_HOC_RESET);



// WEBPACK FOOTER //
// ./src/components/apiHOCs/ProductApiHOC/actions.js